import { formatNumber } from './format-number';
const percentageMetrics = new Set([
  'usage_percentage',
  'true_shooting_percentage',
  'effective_field_goal_percentage',
]);
const hundredthPercentageMetrics = new Set(['possession']);
const thirdDecimalMetrics = ['batting_average', 'on_base_percentage', 'slugging'];
const optionsFor = (metric: string): Intl.NumberFormatOptions => {
  if (percentageMetrics.has(metric) || hundredthPercentageMetrics.has(metric))
    return { style: 'percent', maximumFractionDigits: 1 };
  if (metric === 'xg') return { minimumFractionDigits: 1, maximumFractionDigits: 2 };
  return { maximumFractionDigits: thirdDecimalMetrics.includes(metric) ? 3 : 2 };
};
export const formatStatistic = (metric: string, value: number | null, locale: string) =>
  value === null
    ? '—'
    : formatNumber(
        hundredthPercentageMetrics.has(metric) ? value / 100 : value,
        locale,
        optionsFor(metric),
      );
